export default {
      id: "check-circle-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#check-circle-usage",
      toString: function () {
        return this.url;
      }
    }